"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchResourceLabels = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _apiService = _interopRequireDefault(require("../../../utils/api-service"));

var _utils = require("../../profile-policy/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var fetchResourceLabels = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(consumerEntityId) {
    var params,
        apiPath,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            apiPath = '';

            if (!(0, _utils.isResourcePolicyPath)() && consumerEntityId) {
              apiPath = "/api/resource-manager/profiles/".concat(consumerEntityId, "/associations");
            } else {
              if (!(0, _isEmpty.default)(params)) {
                apiPath = "/api/resource-manager/labels?".concat(new URLSearchParams(params).toString());
              } else {
                apiPath = "/api/resource-manager/labels";
              }
            }

            _context.next = 5;
            return _apiService.default.get(apiPath, {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 5:
            response = _context.sent;
            return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchResourceLabels(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchResourceLabels = fetchResourceLabels;